/**
 * Agentes.
 *
 * Nao se cria agente aqui: quem cadastra pessoa e o liberty/auth. Nesta tela
 * se decide o que a pessoa e **dentro do atendimento** -- papel, equipes,
 * quantas conversas aguenta ao mesmo tempo, e se esta ativa.
 */
export const nav = {
    permissao: 'atendimento.agentes:ver',
    section: 'Configuracao',
    title: 'Agentes',
    icon: 'support_agent',
    route: '/agentes',
    sequence: 12,
};

export default [
    {
        path: '/agentes',
        name: 'agentes',
        component: () => import('./pages/AgentesPage.vue'),
        meta: { requiresAuth: true, permissao: 'atendimento.agentes:ver' },
    },
];
